"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JumpToDate = void 0;
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const prop_types_1 = require("prop-types");
const intl_1 = require("@kyruus/intl");
const calendar_1 = require("@kyruus/calendar");
const messages_1 = __importDefault(require("../../../../lib/messages"));
const styles_1 = require("./styles");
const MOMENT_FORMAT = moment_1.default.localeData().longDateFormat('l');
const INPUT_ID = 'FilterJumpToDateCalendar';
const BaseJumpToDate = ({ date, dateInvalid, intl, onDateChange, setDateInvalid }) => {
    const [calendarFocused, setCalendarFocused] = (0, react_1.useState)(null);
    const containerRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        const input = window.document.getElementById(INPUT_ID);
        if (!input)
            return;
        // react-dates does not delineate between an invalid date and an empty one.
        // Empty should be valid for us but we can't determine that via react-dates API
        // Adding an observer seems to be the only consistent way to check for emptiness 😮‍💨
        // Maybe this should just be a native input[type=date]?
        const observer = new MutationObserver(() => {
            if (!input.value)
                setDateInvalid(false);
        });
        observer.observe(input, { attributeFilter: ['value'], attributes: true });
        return () => observer.disconnect();
        // Include the container ref just so this effect triggers after render.
    }, [setDateInvalid, containerRef]);
    (0, react_1.useEffect)(() => {
        const handleEscape = ({ key }) => {
            if (key === 'Escape')
                setCalendarFocused(false);
        };
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, []);
    const handleDateChange = (newDate) => {
        // if the date entered is not a valid date, date will be null
        setDateInvalid(!(0, moment_1.default)(newDate).isValid());
        onDateChange(newDate);
    };
    return (react_1.default.createElement(styles_1.DatePicker, { className: dateInvalid ? 'invalid' : '', ref: containerRef },
        react_1.default.createElement(calendar_1.SingleDatePicker, { ariaLabel: intl.formatMessage(messages_1.default.ariaJumpToDateCalendarInput), date: date || null, displayFormat: MOMENT_FORMAT, focused: calendarFocused, hideKeyboardShortcutsPanel: true, id: INPUT_ID, inputIconPosition: "before", numberOfMonths: 1, onDateChange: handleDateChange, onFocusChange: ({ focused }) => setCalendarFocused(focused), placeholder: MOMENT_FORMAT, required: false, screenReaderInputMessage: dateInvalid
                ? intl.formatMessage(messages_1.default.jumpToDateInvalidDateError)
                : intl.formatMessage(messages_1.default.ariaJumpToDateInputDescription), showClearDate: true, showDefaultInputIcon: true, small: true }),
        react_1.default.createElement("div", { "aria-hidden": "true", role: "presentation", className: "dateInvalidMessage" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.jumpToDateInvalidDateError)))));
};
BaseJumpToDate.defaultProps = {
    date: null
};
BaseJumpToDate.propTypes = {
    date: (0, prop_types_1.oneOfType)([prop_types_1.object, prop_types_1.string]),
    dateInvalid: prop_types_1.bool.isRequired,
    intl: (0, prop_types_1.shape)({ formatMessage: prop_types_1.func.isRequired }),
    onDateChange: prop_types_1.func.isRequired,
    setDateInvalid: prop_types_1.func.isRequired
};
exports.JumpToDate = (0, intl_1.injectIntl)(BaseJumpToDate);
//# sourceMappingURL=JumpToDate.js.map